import { render, staticRenderFns } from "./GroupCategoryProductList.vue?vue&type=template&id=6b0132ba&scoped=true"
import script from "./GroupCategoryProductList.vue?vue&type=script&lang=js"
export * from "./GroupCategoryProductList.vue?vue&type=script&lang=js"
import style0 from "./GroupCategoryProductList.vue?vue&type=style&index=0&id=6b0132ba&prod&lang=scss"
import style1 from "./GroupCategoryProductList.vue?vue&type=style&index=1&id=6b0132ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0132ba",
  null
  
)

export default component.exports